import "../App.css";
import "../general.css";
import "../queries.css";

import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import z from "zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import axios from "axios";
import config from "../config";
import { toast } from "react-hot-toast";
import InfoPopup from "../components/InfoPopup";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import Seo from "../components/SEO"
import { useFacebookPageView } from "../hook/useFacebookPageView";

const formSchema = z.object({
  name: z
    .string({ required_error: "Name is required" })
    .min(3, "Name must be at least 3 character."),
  email: z.string({ required_error: "Email is required" }).email(),
  message: z.string({ required_error: "Message is required" }),
});

type FormType = z.infer<typeof formSchema>;

function Feedback() {
  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "/feedback", title: "feedback page" });
  }, []);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<FormType>({
    resolver: zodResolver(formSchema),
  });

  const onSubmit: SubmitHandler<FormType> = (data) => {
    axios
      .post(`${config.HOST}/insert_user.php`, {...data, page: 'feedback'}, {headers: {
        'content-type': 'multipart/form-data'
      }})
      .then(() => {
        toast.success('Successfully submitted.')
      })
      .catch(() => {
        toast.error("Failed to send.");
      });
  };

  useEffect(() => {
    window.onresize = () => {
      setWindowWidth(window.innerWidth);
    };
  }, []);

  const [infoVisible, setInfoVisible] = useState(false);

  const toggleInfo = () => {
    setInfoVisible(!infoVisible);
  };

  useFacebookPageView();


  return (
    <motion.main
      exit={{ opacity: 0 }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
    >
    <Seo
      title="Your turn — give it to us"
      description="Give us a feedback"
      url="https://therouseco.com/feedback"
      keywords={["Rouse, drink, rehydration, sex, F*** It, feed back"]}
      uploadDate="2025-07-09"
      includeVideoSchema={false}
    />

      <section className="section-form" style={{ paddingTop: "30px" }}>
        <div className="form-div">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div
              className="heading-primary subheading"
              style={{ padding: "60px 0px", width: "100%" }}
            >
              Contact us{" "}
              <div style={{ display: "flex" }}>
                <FontAwesomeIcon
                  style={{
                    display: windowWidth < 600 ? "flex" : "none",
                    marginTop: "10px",
                    marginLeft: "auto",
                  }}
                  onClick={toggleInfo}
                  icon={faInfoCircle}
                />
              </div>
            </div>
            <InfoPopup
              visible={infoVisible}
              info={
                <>
                  {" "}
                  <p className="">
                  There is nothing more entertaining than hateful comments. Constructive and fun ones could come too.
                  <br />
                  <br />
                  But we don't want to make a joke of everything, so please share your thoughts with us. We are open to any kind of observation and dialogue.
                  </p>
                </>
              }
              onClose={() => {
                setInfoVisible(false);
              }}
            />
            <div className="input-group">
              YOUR NICKNAME*
              <input type="text" {...register("name")}></input>
              {errors.name && <p> {errors.name?.message}</p>}
            </div>
            <div className="input-group">
              EMAIL ADDRESS*
              <input type="email" {...register("email")}></input>
              {errors.email && <p> {errors.email?.message}</p>}
            </div>
            <div className="input-group">
              WHAT IS IN YOUR MIND
              <textarea
                className="multiline"
                style={{ minHeight: "100px" }}
                {...register("message")}
              ></textarea>
              {errors.email && <p> {errors.email?.message}</p>}
            </div>
            <input
              type="submit"
              style={{ marginTop: "70px" }}
              value="Submit"
            ></input>
          </form>
          <div
            className="form-text info-text small-text"
            style={{ color: "white" }}
          >
            <div
              className="heading-primary subheading drawn"
              style={{
                padding: "60px 40px",
                color: "white",
                marginTop: "20px",
              }}
            >
              Give us a Feedback
            </div>
            <p className="">
            There is nothing more entertaining than hateful comments. Constructive and fun ones could come too. 
            <br />
            <br />
            But we don't want to make a joke of everything, so please share your thoughts with us. We are open to any kind of observation and dialogue.
            </p>
          </div>
        </div>
      </section>
    </motion.main>
  );
}

export default Feedback;
